import { BaseApi } from '@/main/baseApi';

import { MODULE_API, NAME } from './constants';

export const apiProvider = new BaseApi(MODULE_API, NAME);
